import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useMemo } from '@redneckz/uni-jsx/lib/hooks';
import { useRegions } from '../../hooks/useRegions.js';
import { SelectControl } from '../../ui-kit/Select/SelectControl.js';
import { validatorObj } from './getObjectValidator.js';
import { getValidation } from './getValidation.js';
export const RegionField = JSX(({ field, input, url }) => {
    const regions = useRegions(url);
    return (_jsx(SelectControl, { label: "\u0424\u0438\u043B\u0438\u0430\u043B", placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0444\u0438\u043B\u0438\u0430\u043B", isSearch: true, options: useMemo(() => regions?.map(({ code = '', name = '' }) => ({ key: code, text: name })), [regions]), ...getValidation(field('region'), validatorObj.region, input?.required) }));
});
//# sourceMappingURL=RegionField.js.map